var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('Form', {
    attrs: {
      "url": "/natureza/create",
      "natureza": {}
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };